<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import AudioRecorder from 'dashboard/components/widgets/WootWriter/AudioRecorder.vue';

const emit = defineEmits(['ready', 'busyChange', 'error']);
const { t } = useI18n();
const recorder = ref(null);
const stage = ref('starting');
const progress = ref('00:00');
const playing = ref(false);
const playbackError = ref(false);
const status = computed(() => t(`INTERNAL_CHAT.AUDIO_STATUS.${stage.value}`));
const state = computed(() => ({
  stage: stage.value,
  progress: progress.value,
  playing: playing.value,
  playbackError: playbackError.value,
}));

const finishRecording = file => {
  stage.value = 'ready';
  emit('ready', file);
  emit('busyChange', false);
};
const onError = error => {
  if (error.phase === 'playback') playbackError.value = true;
  else emit('error', error);
};
const togglePlayStop = () => {
  if (stage.value === 'recording') {
    stage.value = 'processing';
    recorder.value.stopRecording();
  } else if (stage.value === 'ready') {
    playbackError.value = false;
    recorder.value.playPause();
  }
};
defineExpose({ state, togglePlayStop });
</script>

<template>
  <div
    class="absolute inset-x-3 inset-y-2 flex flex-col justify-center gap-1"
    data-testid="internal-chat-audio-recorder"
  >
    <div class="relative w-full">
      <AudioRecorder
        ref="recorder"
        audio-record-format="audio/mp3"
        @recording-started="stage = 'recording'"
        @recorder-progress-changed="progress = $event"
        @finish-record="finishRecording"
        @play="playing = true"
        @pause="playing = false"
        @record-error="onError"
      />
      <div
        v-if="stage === 'recording'"
        class="pointer-events-none absolute inset-x-1 top-1/2 z-10 h-px bg-n-blue-9"
        aria-hidden="true"
        data-testid="internal-chat-audio-baseline"
      />
    </div>
    <div
      class="text-xs text-n-slate-11"
      :class="{ 'sr-only': stage === 'recording' || stage === 'ready' }"
      role="status"
    >
      {{ status }}
    </div>
  </div>
</template>
